'use strict'
module.exports = {
  NODE_ENV: '"production"',
  // API_URL:'http://localhost:5000/api'
  // API_URL: 'https://e3necqclhg.execute-api.us-east-2.amazonaws.com/Prod/api'

  API_URL: 'https://iren6287a6.execute-api.us-east-1.amazonaws.com/Prod/api',
  BLADE_API_KEY: '6506042A-FB33-4A08-9D4D-7006B0BE19DD'

}



// WEBPACK FOOTER //
// ./src/env/production.js